import { formatParams, request } from '@/utils/fetch'

/**
 * COINS
 */
export const getCoinsHistorical = function getCoinsHistorical(baseUrl, symbol, params) {
  return request(`${baseUrl}/coins/historical/${symbol}?${formatParams(params)}`)
}

export const getCoinsLatestSingle = function getCoinsLatestSingle(baseUrl, symbol) {
  return request(`${baseUrl}/coins/latest/${symbol}`)
}

export const getCoinsLatestAll = function getCoinsLatestAll(baseUrl, params) {
  return request(`${baseUrl}/coins/latest?${formatParams(params)}`)
}

export const getCoinsSingleComparison = function getCoinsSingleComparison(baseUrl, symbol, params) {
  return request(`${baseUrl}/coins/historical/comparison/${symbol}?${formatParams(params)}`)
}

export const getCoinsComparison = function getStockComparison(baseUrl, symbol, params) {
  return request(`${baseUrl}/coins/historical/comparison/${symbol}?${formatParams(params)}`)
}

/**
 * FOREX
 */
export const getForexHistorical = function getForexHistorical(baseUrl, symbol, params) {
  return request(`${baseUrl}/forex/historical/${symbol}?${formatParams(params)}`)
}

export const getForexLatestSingle = function getForexLatestSingle(baseUrl, symbol) {
  return request(`${baseUrl}/forex/latest/${symbol}`)
}

export const getForexLatestAll = function getForexLatestAll(baseUrl, params) {
  return request(`${baseUrl}/forex/latest?${formatParams(params)}`)
}

/**
 * STOCKS
 */
export const getStockComparison = function getStockComparison(baseUrl, symbol, params) {
  return request(`${baseUrl}/stocks/historical/comparison/${symbol}?${formatParams(params)}`)
}

export const getStocksLatestAll = function getStocksLatestAll(baseUrl, params) {
  return request(`${baseUrl}/stocks/latest?${formatParams(params)}`)
}

export const getStocksLatestSingle = function getStocksLatestSingle(baseUrl, symbol, params) {
  return request(`${baseUrl}/stocks/latest/${symbol}?${formatParams(params)}`)
}

export const getStocksHistorical = function getStocksHistorical(baseUrl, symbol, params) {
  return request(`${baseUrl}/stocks/historical/${symbol}?${formatParams(params)}`)
}

export default {
  // COINS
  getCoinsHistorical,
  getCoinsLatestSingle,
  getCoinsLatestAll,
  // FOREX
  getForexLatestSingle,
  getForexLatestAll,
  getForexHistorical,
  // STOCKS
  getStockComparison,
  getStocksLatestAll,
  getStocksLatestSingle,
  getStocksHistorical,
}
